import _ from 'lodash';

import { GENERATE_PROGRESS_KIND } from '../GenerateExpression.constants';

const isSelfCorrectEvent = event => event?.kind === GENERATE_PROGRESS_KIND.SELF_CORRECT;

const buildKey = (event, index) => `${event?.atUtc ?? ''}-${event?.turn ?? 0}-${index}`;

export const decorateEvents = events => {
  if (_.isNil(events) || _.isEmpty(events)) {
    return [];
  }

  return events.map((event, index) => ({
    ...event,
    key: buildKey(event, index),
    isSelfCorrect: isSelfCorrectEvent(event),
  }));
};
